var map = {
	"./A.vue": "./src/icons/A.vue",
	"./ActiveTray.vue": "./src/icons/ActiveTray.vue",
	"./Agents.vue": "./src/icons/Agents.vue",
	"./AlertTriangleRed.vue": "./src/icons/AlertTriangleRed.vue",
	"./AlertTriangleYellow.vue": "./src/icons/AlertTriangleYellow.vue",
	"./AndroidBlack.vue": "./src/icons/AndroidBlack.vue",
	"./Announcement.vue": "./src/icons/Announcement.vue",
	"./Apple.vue": "./src/icons/Apple.vue",
	"./AppleBlack.vue": "./src/icons/AppleBlack.vue",
	"./AqsiIntegration.vue": "./src/icons/AqsiIntegration.vue",
	"./ArchiveBox.vue": "./src/icons/ArchiveBox.vue",
	"./ArrowButton.vue": "./src/icons/ArrowButton.vue",
	"./ArrowLeft.vue": "./src/icons/ArrowLeft.vue",
	"./ArrowLeftWhite.vue": "./src/icons/ArrowLeftWhite.vue",
	"./ArrowLineUp.vue": "./src/icons/ArrowLineUp.vue",
	"./ArrowMore.vue": "./src/icons/ArrowMore.vue",
	"./ArrowRightWhite.vue": "./src/icons/ArrowRightWhite.vue",
	"./ArrowsClockwise.vue": "./src/icons/ArrowsClockwise.vue",
	"./ArrowsDownUp.vue": "./src/icons/ArrowsDownUp.vue",
	"./ArrowsIn.vue": "./src/icons/ArrowsIn.vue",
	"./ArrowsOut.vue": "./src/icons/ArrowsOut.vue",
	"./B.vue": "./src/icons/B.vue",
	"./Bank.vue": "./src/icons/Bank.vue",
	"./BankIcon.vue": "./src/icons/BankIcon.vue",
	"./BellIcon.vue": "./src/icons/BellIcon.vue",
	"./Bill.vue": "./src/icons/Bill.vue",
	"./BithdayCake.vue": "./src/icons/BithdayCake.vue",
	"./Bonus.vue": "./src/icons/Bonus.vue",
	"./BottleIcon.vue": "./src/icons/BottleIcon.vue",
	"./BriefCase.vue": "./src/icons/BriefCase.vue",
	"./BriefcaseIcon.vue": "./src/icons/BriefcaseIcon.vue",
	"./Broadcast.vue": "./src/icons/Broadcast.vue",
	"./Brush.vue": "./src/icons/Brush.vue",
	"./Cake.vue": "./src/icons/Cake.vue",
	"./Calendar.vue": "./src/icons/Calendar.vue",
	"./CalendarBlank.vue": "./src/icons/CalendarBlank.vue",
	"./Calendars.vue": "./src/icons/Calendars.vue",
	"./CardIcon.vue": "./src/icons/CardIcon.vue",
	"./CaretDown.vue": "./src/icons/CaretDown.vue",
	"./CaretRight.vue": "./src/icons/CaretRight.vue",
	"./CaretUp.vue": "./src/icons/CaretUp.vue",
	"./Carret.vue": "./src/icons/Carret.vue",
	"./Catalog.vue": "./src/icons/Catalog.vue",
	"./Center.vue": "./src/icons/Center.vue",
	"./ChartLineUpIcon.vue": "./src/icons/ChartLineUpIcon.vue",
	"./Chat.vue": "./src/icons/Chat.vue",
	"./ChatCircle.vue": "./src/icons/ChatCircle.vue",
	"./Check.vue": "./src/icons/Check.vue",
	"./CheckCircle.vue": "./src/icons/CheckCircle.vue",
	"./Checked.vue": "./src/icons/Checked.vue",
	"./Chevron.vue": "./src/icons/Chevron.vue",
	"./ChevronClose.vue": "./src/icons/ChevronClose.vue",
	"./ChevronDown.vue": "./src/icons/ChevronDown.vue",
	"./CircleChecked.vue": "./src/icons/CircleChecked.vue",
	"./ClassicalBuilding.vue": "./src/icons/ClassicalBuilding.vue",
	"./ClockIcon.vue": "./src/icons/ClockIcon.vue",
	"./Close.vue": "./src/icons/Close.vue",
	"./CloseGreen.vue": "./src/icons/CloseGreen.vue",
	"./CloudDownload.vue": "./src/icons/CloudDownload.vue",
	"./Clubcard.vue": "./src/icons/Clubcard.vue",
	"./CocktailIcon.vue": "./src/icons/CocktailIcon.vue",
	"./Coin.vue": "./src/icons/Coin.vue",
	"./CoinIcon.vue": "./src/icons/CoinIcon.vue",
	"./ConvenienceStore.vue": "./src/icons/ConvenienceStore.vue",
	"./CookIcon.vue": "./src/icons/CookIcon.vue",
	"./Copy.vue": "./src/icons/Copy.vue",
	"./CopySimple.vue": "./src/icons/CopySimple.vue",
	"./CreditCard.vue": "./src/icons/CreditCard.vue",
	"./CreditCardSimple.vue": "./src/icons/CreditCardSimple.vue",
	"./Crm.vue": "./src/icons/Crm.vue",
	"./DiceOne.vue": "./src/icons/DiceOne.vue",
	"./DiceThree.vue": "./src/icons/DiceThree.vue",
	"./DiceTwo.vue": "./src/icons/DiceTwo.vue",
	"./Discount.vue": "./src/icons/Discount.vue",
	"./DobleCarret.vue": "./src/icons/DobleCarret.vue",
	"./DocTabletIcon.vue": "./src/icons/DocTabletIcon.vue",
	"./DocumentsIcon.vue": "./src/icons/DocumentsIcon.vue",
	"./DoorIcon.vue": "./src/icons/DoorIcon.vue",
	"./Dots.vue": "./src/icons/Dots.vue",
	"./Download.vue": "./src/icons/Download.vue",
	"./Dragable.vue": "./src/icons/Dragable.vue",
	"./Earth.vue": "./src/icons/Earth.vue",
	"./Edit.vue": "./src/icons/Edit.vue",
	"./Empty.vue": "./src/icons/Empty.vue",
	"./EnvelopeSimple.vue": "./src/icons/EnvelopeSimple.vue",
	"./EyeClosed.vue": "./src/icons/EyeClosed.vue",
	"./EyeOpened.vue": "./src/icons/EyeOpened.vue",
	"./FaceFrown.vue": "./src/icons/FaceFrown.vue",
	"./FaceNeutral.vue": "./src/icons/FaceNeutral.vue",
	"./FaceSmile.vue": "./src/icons/FaceSmile.vue",
	"./FakeLogo.vue": "./src/icons/FakeLogo.vue",
	"./FileIcon.vue": "./src/icons/FileIcon.vue",
	"./FileSimple.vue": "./src/icons/FileSimple.vue",
	"./FileText.vue": "./src/icons/FileText.vue",
	"./FolderIcon.vue": "./src/icons/FolderIcon.vue",
	"./ForkAndKnifeIcon.vue": "./src/icons/ForkAndKnifeIcon.vue",
	"./ForkKnife.vue": "./src/icons/ForkKnife.vue",
	"./Funnel.vue": "./src/icons/Funnel.vue",
	"./Gamburger.vue": "./src/icons/Gamburger.vue",
	"./Gear.vue": "./src/icons/Gear.vue",
	"./GemIcon.vue": "./src/icons/GemIcon.vue",
	"./Gift.vue": "./src/icons/Gift.vue",
	"./Globe.vue": "./src/icons/Globe.vue",
	"./Google.vue": "./src/icons/Google.vue",
	"./GraduationCap.vue": "./src/icons/GraduationCap.vue",
	"./GraduationCapIcon.vue": "./src/icons/GraduationCapIcon.vue",
	"./HamburgerMenu.vue": "./src/icons/HamburgerMenu.vue",
	"./HandPointing.vue": "./src/icons/HandPointing.vue",
	"./Handset.vue": "./src/icons/Handset.vue",
	"./HandshakeIcon.vue": "./src/icons/HandshakeIcon.vue",
	"./Headset.vue": "./src/icons/Headset.vue",
	"./Home.vue": "./src/icons/Home.vue",
	"./Huawei.vue": "./src/icons/Huawei.vue",
	"./I.vue": "./src/icons/I.vue",
	"./IikoIntegration.vue": "./src/icons/IikoIntegration.vue",
	"./ImagePlus.vue": "./src/icons/ImagePlus.vue",
	"./Info.vue": "./src/icons/Info.vue",
	"./Laptop.vue": "./src/icons/Laptop.vue",
	"./LaptopIcon.vue": "./src/icons/LaptopIcon.vue",
	"./Left.vue": "./src/icons/Left.vue",
	"./LikeIcon.vue": "./src/icons/LikeIcon.vue",
	"./Location.vue": "./src/icons/Location.vue",
	"./Lock.vue": "./src/icons/Lock.vue",
	"./LockIcon.vue": "./src/icons/LockIcon.vue",
	"./LockWithKeyIcon.vue": "./src/icons/LockWithKeyIcon.vue",
	"./LoyaltyImage.vue": "./src/icons/LoyaltyImage.vue",
	"./MagnifyingGlass.vue": "./src/icons/MagnifyingGlass.vue",
	"./MailIcon.vue": "./src/icons/MailIcon.vue",
	"./MailboxIcon.vue": "./src/icons/MailboxIcon.vue",
	"./MailboxTwoIcon.vue": "./src/icons/MailboxTwoIcon.vue",
	"./MapIcon.vue": "./src/icons/MapIcon.vue",
	"./MapIconStroke.vue": "./src/icons/MapIconStroke.vue",
	"./MapPinLine.vue": "./src/icons/MapPinLine.vue",
	"./MarkGreen.vue": "./src/icons/MarkGreen.vue",
	"./MarkRed.vue": "./src/icons/MarkRed.vue",
	"./MarkSuccess.vue": "./src/icons/MarkSuccess.vue",
	"./Max.vue": "./src/icons/Max.vue",
	"./MedalIcon.vue": "./src/icons/MedalIcon.vue",
	"./MedalStar.vue": "./src/icons/MedalStar.vue",
	"./MemoIcon.vue": "./src/icons/MemoIcon.vue",
	"./Minus.vue": "./src/icons/Minus.vue",
	"./MinusCircle.vue": "./src/icons/MinusCircle.vue",
	"./Mono.vue": "./src/icons/Mono.vue",
	"./MoveBottom.vue": "./src/icons/MoveBottom.vue",
	"./MoveLeft.vue": "./src/icons/MoveLeft.vue",
	"./MoveRight.vue": "./src/icons/MoveRight.vue",
	"./MoveTop.vue": "./src/icons/MoveTop.vue",
	"./Needle.vue": "./src/icons/Needle.vue",
	"./Newspaper.vue": "./src/icons/Newspaper.vue",
	"./NextPageIcon.vue": "./src/icons/NextPageIcon.vue",
	"./NumberFourIcon.vue": "./src/icons/NumberFourIcon.vue",
	"./NumberOneIcon.vue": "./src/icons/NumberOneIcon.vue",
	"./NumberThreeIcon.vue": "./src/icons/NumberThreeIcon.vue",
	"./NumberTwoIcon.vue": "./src/icons/NumberTwoIcon.vue",
	"./Offline.vue": "./src/icons/Offline.vue",
	"./Ok.vue": "./src/icons/Ok.vue",
	"./OkIcon.vue": "./src/icons/OkIcon.vue",
	"./OrderBicycle.vue": "./src/icons/OrderBicycle.vue",
	"./OrderStore.vue": "./src/icons/OrderStore.vue",
	"./OrderTote.vue": "./src/icons/OrderTote.vue",
	"./PChart.vue": "./src/icons/PChart.vue",
	"./PageSavingUp.vue": "./src/icons/PageSavingUp.vue",
	"./PaginationArrowLeft.vue": "./src/icons/PaginationArrowLeft.vue",
	"./PaginationArrowLeftDisabled.vue": "./src/icons/PaginationArrowLeftDisabled.vue",
	"./PaginationArrowRight.vue": "./src/icons/PaginationArrowRight.vue",
	"./PaginationArrowRightDisabled.vue": "./src/icons/PaginationArrowRightDisabled.vue",
	"./PaperClip.vue": "./src/icons/PaperClip.vue",
	"./PartyIcon.vue": "./src/icons/PartyIcon.vue",
	"./Pause.vue": "./src/icons/Pause.vue",
	"./PauseCircle.vue": "./src/icons/PauseCircle.vue",
	"./Pencil.vue": "./src/icons/Pencil.vue",
	"./PencilSimple.vue": "./src/icons/PencilSimple.vue",
	"./Phone.vue": "./src/icons/Phone.vue",
	"./PhoneColor.vue": "./src/icons/PhoneColor.vue",
	"./PhoneIcon.vue": "./src/icons/PhoneIcon.vue",
	"./PhoneSimple.vue": "./src/icons/PhoneSimple.vue",
	"./Plane.vue": "./src/icons/Plane.vue",
	"./Play.vue": "./src/icons/Play.vue",
	"./Plus.vue": "./src/icons/Plus.vue",
	"./PlusBtn.vue": "./src/icons/PlusBtn.vue",
	"./PlusGradient.vue": "./src/icons/PlusGradient.vue",
	"./PlusInCircle.vue": "./src/icons/PlusInCircle.vue",
	"./Premium.vue": "./src/icons/Premium.vue",
	"./PrevPageIcon.vue": "./src/icons/PrevPageIcon.vue",
	"./Privat24.vue": "./src/icons/Privat24.vue",
	"./ProfileSettings.vue": "./src/icons/ProfileSettings.vue",
	"./Puzzle.vue": "./src/icons/Puzzle.vue",
	"./QAppleDownload.vue": "./src/icons/QAppleDownload.vue",
	"./QArrowLeft.vue": "./src/icons/QArrowLeft.vue",
	"./QCreditCard.vue": "./src/icons/QCreditCard.vue",
	"./QGift.vue": "./src/icons/QGift.vue",
	"./QGoogleDownload.vue": "./src/icons/QGoogleDownload.vue",
	"./QPencilSimple.vue": "./src/icons/QPencilSimple.vue",
	"./QPlus.vue": "./src/icons/QPlus.vue",
	"./QReceipt.vue": "./src/icons/QReceipt.vue",
	"./QTrash.vue": "./src/icons/QTrash.vue",
	"./QbSad.vue": "./src/icons/QbSad.vue",
	"./Qbeek.vue": "./src/icons/Qbeek.vue",
	"./QbeekForgotPassword.vue": "./src/icons/QbeekForgotPassword.vue",
	"./QbeekLike.vue": "./src/icons/QbeekLike.vue",
	"./QbeekLogin.vue": "./src/icons/QbeekLogin.vue",
	"./QbeekLogo.vue": "./src/icons/QbeekLogo.vue",
	"./QbeekLogoSmall.vue": "./src/icons/QbeekLogoSmall.vue",
	"./QrCode.vue": "./src/icons/QrCode.vue",
	"./QrCodeRound.vue": "./src/icons/QrCodeRound.vue",
	"./QrCodeThree.vue": "./src/icons/QrCodeThree.vue",
	"./QrCodeTwo.vue": "./src/icons/QrCodeTwo.vue",
	"./QrTrash.vue": "./src/icons/QrTrash.vue",
	"./QuestionSign.vue": "./src/icons/QuestionSign.vue",
	"./RHome.vue": "./src/icons/RHome.vue",
	"./Rainbow.vue": "./src/icons/Rainbow.vue",
	"./RatingStar.vue": "./src/icons/RatingStar.vue",
	"./Receipt.vue": "./src/icons/Receipt.vue",
	"./ReceiptIcon.vue": "./src/icons/ReceiptIcon.vue",
	"./RecycleBin.vue": "./src/icons/RecycleBin.vue",
	"./RedSquareTrash.vue": "./src/icons/RedSquareTrash.vue",
	"./Right.vue": "./src/icons/Right.vue",
	"./RkeeperIntegration.vue": "./src/icons/RkeeperIntegration.vue",
	"./Rocket.vue": "./src/icons/Rocket.vue",
	"./RocketBig.vue": "./src/icons/RocketBig.vue",
	"./SbpIcon.vue": "./src/icons/SbpIcon.vue",
	"./SearchClear.vue": "./src/icons/SearchClear.vue",
	"./SearchGlass.vue": "./src/icons/SearchGlass.vue",
	"./SearchIcon.vue": "./src/icons/SearchIcon.vue",
	"./SettingsIcon.vue": "./src/icons/SettingsIcon.vue",
	"./Share.vue": "./src/icons/Share.vue",
	"./Signout.vue": "./src/icons/Signout.vue",
	"./SmallArrowTagOff.vue": "./src/icons/SmallArrowTagOff.vue",
	"./SmallArrowTagOn.vue": "./src/icons/SmallArrowTagOn.vue",
	"./SmileyIcon.vue": "./src/icons/SmileyIcon.vue",
	"./Standard.vue": "./src/icons/Standard.vue",
	"./Star.vue": "./src/icons/Star.vue",
	"./Statistic.vue": "./src/icons/Statistic.vue",
	"./Stop.vue": "./src/icons/Stop.vue",
	"./StopIcon.vue": "./src/icons/StopIcon.vue",
	"./StoreIcon.vue": "./src/icons/StoreIcon.vue",
	"./SystemError.vue": "./src/icons/SystemError.vue",
	"./Tablet.vue": "./src/icons/Tablet.vue",
	"./Target.vue": "./src/icons/Target.vue",
	"./Telegram.vue": "./src/icons/Telegram.vue",
	"./TelegramIntegration.vue": "./src/icons/TelegramIntegration.vue",
	"./ThreeDots.vue": "./src/icons/ThreeDots.vue",
	"./ThreeUsers.vue": "./src/icons/ThreeUsers.vue",
	"./ThreeVerticalDot.vue": "./src/icons/ThreeVerticalDot.vue",
	"./Trash.vue": "./src/icons/Trash.vue",
	"./Trophy.vue": "./src/icons/Trophy.vue",
	"./U.vue": "./src/icons/U.vue",
	"./UnChecked.vue": "./src/icons/UnChecked.vue",
	"./Upload.vue": "./src/icons/Upload.vue",
	"./User.vue": "./src/icons/User.vue",
	"./UserCircleGear.vue": "./src/icons/UserCircleGear.vue",
	"./UserIcon.vue": "./src/icons/UserIcon.vue",
	"./UserPlus.vue": "./src/icons/UserPlus.vue",
	"./UserSimple.vue": "./src/icons/UserSimple.vue",
	"./Users.vue": "./src/icons/Users.vue",
	"./Viber.vue": "./src/icons/Viber.vue",
	"./Vip.vue": "./src/icons/Vip.vue",
	"./Wallet.vue": "./src/icons/Wallet.vue",
	"./WalletCard.vue": "./src/icons/WalletCard.vue",
	"./WarningCircle.vue": "./src/icons/WarningCircle.vue",
	"./WarningTriangle.vue": "./src/icons/WarningTriangle.vue",
	"./WaveIcon.vue": "./src/icons/WaveIcon.vue",
	"./Whatsapp.vue": "./src/icons/Whatsapp.vue",
	"./WhatsappIntegration.vue": "./src/icons/WhatsappIntegration.vue",
	"./WifiIcon.vue": "./src/icons/WifiIcon.vue",
	"./WineIcon.vue": "./src/icons/WineIcon.vue",
	"./X.vue": "./src/icons/X.vue",
	"./X1.vue": "./src/icons/X1.vue",
	"./X12.vue": "./src/icons/X12.vue",
	"./Xclose.vue": "./src/icons/Xclose.vue",
	"./ZoomIn.vue": "./src/icons/ZoomIn.vue",
	"./ZoomOut.vue": "./src/icons/ZoomOut.vue",
	"./package/AppLe.vue": "./src/icons/package/AppLe.vue",
	"./package/BanAna.vue": "./src/icons/package/BanAna.vue",
	"./package/BeerTwo.vue": "./src/icons/package/BeerTwo.vue",
	"./package/BooKmark.vue": "./src/icons/package/BooKmark.vue",
	"./package/BraInstorming.vue": "./src/icons/package/BraInstorming.vue",
	"./package/BreAd.vue": "./src/icons/package/BreAd.vue",
	"./package/BurGerbag.vue": "./src/icons/package/BurGerbag.vue",
	"./package/BusInessdialog.vue": "./src/icons/package/BusInessdialog.vue",
	"./package/BusInesstime.vue": "./src/icons/package/BusInesstime.vue",
	"./package/CaffeTatte.vue": "./src/icons/package/CaffeTatte.vue",
	"./package/CanDy.vue": "./src/icons/package/CanDy.vue",
	"./package/CapItaltwo.vue": "./src/icons/package/CapItaltwo.vue",
	"./package/CasHregister.vue": "./src/icons/package/CasHregister.vue",
	"./package/CheEseburger.vue": "./src/icons/package/CheEseburger.vue",
	"./package/CheRry.vue": "./src/icons/package/CheRry.vue",
	"./package/ChiCken.vue": "./src/icons/package/ChiCken.vue",
	"./package/ChiCkenlegs.vue": "./src/icons/package/ChiCkenlegs.vue",
	"./package/CocktailTwo.vue": "./src/icons/package/CocktailTwo.vue",
	"./package/CoffeeTithTarvhmallow.vue": "./src/icons/package/CoffeeTithTarvhmallow.vue",
	"./package/CoffeeToTo.vue": "./src/icons/package/CoffeeToTo.vue",
	"./package/CoffeeTupTevenTineTfive.vue": "./src/icons/package/CoffeeTupTevenTineTfive.vue",
	"./package/CoffeeTupTixTineT6.vue": "./src/icons/package/CoffeeTupTixTineT6.vue",
	"./package/ComBochart.vue": "./src/icons/package/ComBochart.vue",
	"./package/ComMunication.vue": "./src/icons/package/ComMunication.vue",
	"./package/CooKie.vue": "./src/icons/package/CooKie.vue",
	"./package/CorN.vue": "./src/icons/package/CorN.vue",
	"./package/CupCake.vue": "./src/icons/package/CupCake.vue",
	"./package/DrinkThree.vue": "./src/icons/package/DrinkThree.vue",
	"./package/DrinkTive.vue": "./src/icons/package/DrinkTive.vue",
	"./package/DrinkTour.vue": "./src/icons/package/DrinkTour.vue",
	"./package/EcoNomicimprovement.vue": "./src/icons/package/EcoNomicimprovement.vue",
	"./package/FinAncialanalytics.vue": "./src/icons/package/FinAncialanalytics.vue",
	"./package/FisH.vue": "./src/icons/package/FisH.vue",
	"./package/ForKknife.vue": "./src/icons/package/ForKknife.vue",
	"./package/FreNchfries.vue": "./src/icons/package/FreNchfries.vue",
	"./package/FriEs.vue": "./src/icons/package/FriEs.vue",
	"./package/GifT.vue": "./src/icons/package/GifT.vue",
	"./package/GifTboxtwothree.vue": "./src/icons/package/GifTboxtwothree.vue",
	"./package/GraPes.vue": "./src/icons/package/GraPes.vue",
	"./package/HotDog.vue": "./src/icons/package/HotDog.vue",
	"./package/IceCreamcone.vue": "./src/icons/package/IceCreamcone.vue",
	"./package/IceCreamconeo.vue": "./src/icons/package/IceCreamconeo.vue",
	"./package/IcedToffee.vue": "./src/icons/package/IcedToffee.vue",
	"./package/IdeA.vue": "./src/icons/package/IdeA.vue",
	"./package/InvEstmentportfolio.vue": "./src/icons/package/InvEstmentportfolio.vue",
	"./package/InvEstmenttime.vue": "./src/icons/package/InvEstmenttime.vue",
	"./package/IrivhToffee.vue": "./src/icons/package/IrivhToffee.vue",
	"./package/KonTanna.vue": "./src/icons/package/KonTanna.vue",
	"./package/LatteTacchiato.vue": "./src/icons/package/LatteTacchiato.vue",
	"./package/LemonadeTitcher.vue": "./src/icons/package/LemonadeTitcher.vue",
	"./package/LolLipop.vue": "./src/icons/package/LolLipop.vue",
	"./package/LoneTacchiato.vue": "./src/icons/package/LoneTacchiato.vue",
	"./package/LoneTrinkThree.vue": "./src/icons/package/LoneTrinkThree.vue",
	"./package/MarearitaTineTzero.vue": "./src/icons/package/MarearitaTineTzero.vue",
	"./package/MartiniTineTfive.vue": "./src/icons/package/MartiniTineTfive.vue",
	"./package/MedAl.vue": "./src/icons/package/MedAl.vue",
	"./package/MilkTottle.vue": "./src/icons/package/MilkTottle.vue",
	"./package/MonEybox.vue": "./src/icons/package/MonEybox.vue",
	"./package/MufFin.vue": "./src/icons/package/MufFin.vue",
	"./package/NegAtivedynamic.vue": "./src/icons/package/NegAtivedynamic.vue",
	"./package/NewContact.vue": "./src/icons/package/NewContact.vue",
	"./package/NooDleboxt.vue": "./src/icons/package/NooDleboxt.vue",
	"./package/NooDles.vue": "./src/icons/package/NooDles.vue",
	"./package/PacKage.vue": "./src/icons/package/PacKage.vue",
	"./package/PizZaboxes.vue": "./src/icons/package/PizZaboxes.vue",
	"./package/PizZat.vue": "./src/icons/package/PizZat.vue",
	"./package/PopSicle.vue": "./src/icons/package/PopSicle.vue",
	"./package/PorKleg.vue": "./src/icons/package/PorKleg.vue",
	"./package/PreSentationtwo.vue": "./src/icons/package/PreSentationtwo.vue",
	"./package/PreSentationtwoone.vue": "./src/icons/package/PreSentationtwoone.vue",
	"./package/RafToffee.vue": "./src/icons/package/RafToffee.vue",
	"./package/RoaStchicken.vue": "./src/icons/package/RoaStchicken.vue",
	"./package/SauSage.vue": "./src/icons/package/SauSage.vue",
	"./package/SauSaget.vue": "./src/icons/package/SauSaget.vue",
	"./package/ShrImp.vue": "./src/icons/package/ShrImp.vue",
	"./package/StaTistics.vue": "./src/icons/package/StaTistics.vue",
	"./package/SummerTrinkTineTc.vue": "./src/icons/package/SummerTrinkTineTc.vue",
	"./package/SusHit.vue": "./src/icons/package/SusHit.vue",
	"./package/TacO.vue": "./src/icons/package/TacO.vue",
	"./package/TakEaway.vue": "./src/icons/package/TakEaway.vue",
	"./package/TakEawaycoffeef.vue": "./src/icons/package/TakEawaycoffeef.vue",
	"./package/TakEawayfries.vue": "./src/icons/package/TakEawayfries.vue",
	"./package/TakEawayicecream.vue": "./src/icons/package/TakEawayicecream.vue",
	"./package/TakEawaypizza.vue": "./src/icons/package/TakEawaypizza.vue",
	"./package/TakEawaypizzabox.vue": "./src/icons/package/TakEawaypizzabox.vue",
	"./package/TakEawaysushi.vue": "./src/icons/package/TakEawaysushi.vue",
	"./package/TakEout.vue": "./src/icons/package/TakEout.vue",
	"./package/TakEoutboxt.vue": "./src/icons/package/TakEoutboxt.vue",
	"./package/TakEoutburger.vue": "./src/icons/package/TakEoutburger.vue",
	"./package/TakEoutburgert.vue": "./src/icons/package/TakEoutburgert.vue",
	"./package/TakEoute.vue": "./src/icons/package/TakEoute.vue",
	"./package/TakEouthotdog.vue": "./src/icons/package/TakEouthotdog.vue",
	"./package/TakEoutn.vue": "./src/icons/package/TakEoutn.vue",
	"./package/TakEoutof.vue": "./src/icons/package/TakEoutof.vue",
	"./package/TakEoutos.vue": "./src/icons/package/TakEoutos.vue",
	"./package/TakEoutsandwich.vue": "./src/icons/package/TakEoutsandwich.vue",
	"./package/TakEoutt.vue": "./src/icons/package/TakEoutt.vue",
	"./package/TakeTwayTrappe.vue": "./src/icons/package/TakeTwayTrappe.vue",
	"./package/TakeawayToffeevTineTthree.vue": "./src/icons/package/TakeawayToffeevTineTthree.vue",
	"./package/TimEtoinvest.vue": "./src/icons/package/TimEtoinvest.vue",
	"./package/TopOfsuccess.vue": "./src/icons/package/TopOfsuccess.vue",
	"./package/TroPhy.vue": "./src/icons/package/TroPhy.vue",
	"./package/VAmericano.vue": "./src/icons/package/VAmericano.vue",
	"./package/VBottle.vue": "./src/icons/package/VBottle.vue",
	"./package/VCola.vue": "./src/icons/package/VCola.vue",
	"./package/VDorzo.vue": "./src/icons/package/VDorzo.vue",
	"./package/VDrink.vue": "./src/icons/package/VDrink.vue",
	"./package/VDrinkv.vue": "./src/icons/package/VDrinkv.vue",
	"./package/VFrappe.vue": "./src/icons/package/VFrappe.vue",
	"./package/VGlace.vue": "./src/icons/package/VGlace.vue",
	"./package/VLemonade.vue": "./src/icons/package/VLemonade.vue",
	"./package/VLiquor.vue": "./src/icons/package/VLiquor.vue",
	"./package/VMarocchino.vue": "./src/icons/package/VMarocchino.vue",
	"./package/VMocha.vue": "./src/icons/package/VMocha.vue",
	"./package/VRivtretto.vue": "./src/icons/package/VRivtretto.vue",
	"./package/VTea.vue": "./src/icons/package/VTea.vue",
	"./package/VVienneve.vue": "./src/icons/package/VVienneve.vue",
	"./package/VWallet.vue": "./src/icons/package/VWallet.vue",
	"./package/VWater.vue": "./src/icons/package/VWater.vue",
	"./package/WalLet.vue": "./src/icons/package/WalLet.vue",
	"./package/WinNer.vue": "./src/icons/package/WinNer.vue",
	"./package/WineThree.vue": "./src/icons/package/WineThree.vue",
	"./package/WineTourTineTightseven.vue": "./src/icons/package/WineTourTineTightseven.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons sync recursive \\.vue$";